module.exports = __webpack_public_path__ + "static/img/ic_high@2x.5499996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_high@2x.png
// module id = pJfo
// module chunks = 1